<template>
  <div v-click-outside="closeSideBar">
    <header-menu :expand-nav="expandNav" @toggle-sidebar="toggleSideBar" />
    <side-menu :is-show="showSideMenu" @close-sidebar="closeSideBar" />
  </div>
</template>
<script>
import SideMenu from '@/components/layout/SideMenu';
import HeaderMenu from '@/components/layout/HeaderMenu';

export default {
  name: 'PageLayout',
  components: {
    SideMenu,
    HeaderMenu,
  },
  data() {
    return {
      showSideMenu: false,
      expandNav: false,
    };
  },
  methods: {
    toggleSideBar(isShow) {
      this.expandNav = isShow;
      this.showSideMenu = isShow;
    },
    closeSideBar() {
      this.expandNav = false;
      this.showSideMenu = false;
    },
  },
};
</script>
